import { Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FormSwitch } from "@/components/jobOffer/ui";

const ScoringToggle = ({ checked, onChange }) => {
    const { t } = useTranslation("jobOffer");
    return (
        <Box mb={4} p={3} borderRadius={10} border="1px solid" borderColor="gray.200" bg="white">
            <FormSwitch
                label={t("modal.scoringToggle.label")}
                description={t("modal.scoringToggle.hint")}
                checked={!!checked}
                onChange={onChange}
            />
        </Box>
    );
};

export default ScoringToggle;
